"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var baseTracker_1 = tslib_1.__importDefault(require("../base/baseTracker"));
var mtMetaData_1 = tslib_1.__importDefault(require("../metaData/mtMetaData"));
var const_1 = require("../utils/const");
var config_1 = tslib_1.__importDefault(require("../config"));
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var mt_transport_1 = tslib_1.__importDefault(require("../transports/mt-transport"));
var mtQueue_1 = tslib_1.__importDefault(require("../queues/mtQueue"));
var MtTracker = /** @class */ (function (_super) {
    tslib_1.__extends(MtTracker, _super);
    function MtTracker(options) {
        var _this = _super.call(this) || this;
        var project = options.project, version = options.version, common = options.common, transportOption = options.transportOption, pluginOptions = tslib_1.__rest(options, ["project", "version", "common", "transportOption"]);
        _this.metaData = new mtMetaData_1.default(project, version, _this);
        _this.config = new config_1.default(common);
        // 初始化服务端信息及 transport
        var transport = new mt_transport_1.default(tslib_1.__assign({ endpoint: const_1.CATEGORY }, transportOption));
        _this.queue = new mtQueue_1.default(transport, _this.config, _this.metaData);
        var customTransport = new mt_transport_1.default({ endpoint: const_1.CUSTOM_CATEGORY });
        _this.custom_queue = new mtQueue_1.default(customTransport, _this.config, _this.metaData);
        // metaData 需要监听 SPA 模式 PV 变动 更新 visitId
        _this.metaData.listenSPAPV();
        _this.initPlugins(pluginOptions);
        _super.prototype.handlePreload.call(_this);
        return _this;
    }
    MtTracker.prototype.initPlugins = function (pluginOptions) {
        var _this = this;
        MtTracker._pluginCtorMap.forEach(function (pluginCtor, pluginName) {
            var pluginOption = pluginOptions[pluginName];
            if (!(pluginOption === null || pluginOption === void 0 ? void 0 : pluginOption.disable)) {
                var plugin = new pluginCtor(_this.queue, pluginOption);
                if (!plugin.config.disable) {
                    _this.setPluginInsMap(pluginName, plugin);
                    plugin.init();
                }
            }
        });
    };
    MtTracker.use = function (pluginCtor) {
        if (this._pluginCtorMap.has(pluginCtor.id)) {
            logger_1.default.warn('插件已加载 不能重复加载');
            return;
        }
        this._pluginCtorMap.set(pluginCtor.id, pluginCtor);
    };
    MtTracker._pluginCtorMap = new Map();
    return MtTracker;
}(baseTracker_1.default));
exports.default = MtTracker;
//# sourceMappingURL=mtTracker.js.map